import React, { useEffect, useRef } from 'react';
import "./confirmModal.scss"
import closeBlack from "../../../../assets/credits/close_black_24dp.svg";


interface ConfirmModalProps {
  handleClose: any;
  children: any;
  open: boolean;
}



const ConfirmModal: React.FC<ConfirmModalProps> = ({ handleClose, open, children }) => {
  const ref = useRef(null) as any;

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current?.contains(event.target)) {
        handleClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {open &&
        <>
          <div className="mentoria-modal-container"></div>
          <main className="mentoria-modal-content" ref={ref}>
            <div className="mentoria-modal-content__close" onClick={handleClose}><img src={closeBlack} alt="" /></div>
            {children}
          </main>
        </>
      }
    </>
  )
};

export default ConfirmModal;